// extracted by mini-css-extract-plugin
export default {"wrap":"MiniScoreChart_wrap__zg6RH"};